import { useEffect, useState } from 'react'
import { apiURL } from '../utilities/URLs'
import { useChartConnect } from '@chartapi/react-connect'
import posthog from 'posthog-js'
import { useNavigate } from 'react-router-dom'
import { customerData } from '../utilities/CustomerData'
import { refreshAccessToken } from '../utilities/extensions'

export default function ChartInstantFlow({ setReload }) {
  const navigate = useNavigate()
  const [status, setStatus] = useState('initial')

  const onSuccess = ({ code }) => {
    handleUploadChartCode(code)
  }

  const onError = ({ errorMessage }) => {
    posthog.capture('chart_error', { error_message: errorMessage })
  }

  const onClose = () => console.log('User exited Chart Connect')

  const { open } = useChartConnect({
    clientId: process.env.REACT_APP_CHART_CLIENT_ID,
    zIndex: 999,
    sandbox: false,
    flow: 'full-irs-online-account',
    onSuccess,
    onError,
    onClose
  })

  const handleUploadChartCode = async (code) => {
    setStatus('loading')

    const chartInstantFlowResponse = await fetch(`${apiURL}/api/chartInstantFlow?contactId=${encodeURIComponent(customerData.customerLeadData.leadContact.contactId)}&code=${encodeURIComponent(code)}&leadStageId=${encodeURIComponent(customerData.customerLeadData.leadStage.leadStageId)}`, {
      method: 'GET',
      headers: {
        'Authorization': customerData.accessToken
      }
    })

    const chartInstantFlowData = await chartInstantFlowResponse.json()
    if(chartInstantFlowData.response.error) {
      if(chartInstantFlowData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleUploadChartCode(code) : navigate('/', { state: { expired: true } })
      } else
        console.error(chartInstantFlowData.response.error)
    } else
      setStatus('success')
  }

  useEffect(() => {
    open()
  }, [])

  const renderContent = () => {
    switch (status) {
      case 'initial':
        return (
          <>
            <h2 className='text-xl font-semibold text-center'>
              Reauthorize Your Account
            </h2>
            <p className='text-center text-gray-600'>
              Click the button below to log in with your ID.me account and reauthorize access.
            </p>
            <button
              onClick={open}
              className='mt-6 px-6 py-3 bg-primaryColor text-white rounded-lg shadow hover:bg-primaryDarkColor transition'
            >
              Reauthorize via ID.me
            </button>
          </>
        )
      case 'loading':
        return (
          <div className='text-center'>
            <h2 className='text-xl font-semibold animate-pulse text-blue-700'>
              Reauthorizing your account...
            </h2>
            <p className='text-gray-500 mt-2'>Please wait while we complete the process.</p>
          </div>
        )
      case 'success':
        return (
          <>
            <h2 className='text-xl font-semibold text-green-600 text-center'>
              You have successfully reauthorized!
            </h2>
            <p className='text-center text-gray-600 mt-2'>
              Click the button below to return to your dashboard.
            </p>
            <button
              onClick={() => { setReload(true); navigate('/dashboard') }}
              className='mt-6 px-6 py-3 bg-primaryColor text-white rounded-lg shadow hover:bg-primaryDarkColor transition'
            >
              Return to Dashboard
            </button>
          </>
        )
      default:
        return null
    }
  }

  return (
    <div className='w-screen flex items-center justify-center px-4 mt-10'>
      <div className='bg-white rounded-2xl shadow-lg p-8 max-w-md w-full flex flex-col items-center gap-6'>
        {renderContent()}
      </div>
    </div>
  )
}
